import moment from 'moment';
import { CONTRACT_TYPES } from '../Contracts/contract_enums';

export const DEFAULT_PARAMS = {
  modal: true
};

//These values must remain URI-safe
export const REQUEST_TYPE = {
  IndustrialOwnership: 'cambio-titular-industrial',
  ContributionExemption: 'exencion-contribucion'
};

export const REQUEST_TYPE_CONTRACT_TYPE = {
  [REQUEST_TYPE.IndustrialOwnership]: {
    contractTypes: [CONTRACT_TYPES.Industrial, CONTRACT_TYPES.Unregulated]
  },
  [REQUEST_TYPE.ContributionExemption]: {
    contractTypes: [CONTRACT_TYPES.Industrial, CONTRACT_TYPES.Unregulated]
  }
};

const PROCEDURE_TYPE = {
  NewGasService: 'Solicitud de nuevo servicio de Gas Natural',
  ReplenishmentResourceDenial:
    'Presentar recurso de reposición y en subsidio de apelación sobre la negación del servicio de Gas Natural',
  Feasibility: 'Solicitud de factibilidad - Constructores',
  OtherRequest: 'Otras solicitudes'
};

const IDENTIFICATION_TYPES = {
  CC: 'CC',
  PP: 'PP',
  CE: 'CE',
  NIT: 'NIT'
};

export const FORM_ID = 'Pqr_service_form';

export const PQR_STEPS = [
  {
    label: 'Datos del servicio'
  },
  {
    label: 'Información de contacto'
  },
  {
    label: 'Detalle de la solicitud'
  }
];

export const PROCEDURE_TYPE_OPTIONS = [
  { value: 1, label: PROCEDURE_TYPE.NewGasService },
  {
    value: 2,
    label: PROCEDURE_TYPE.ReplenishmentResourceDenial
  },
  { value: 3, label: PROCEDURE_TYPE.Feasibility },
  { value: 4, label: PROCEDURE_TYPE.OtherRequest }
];

export const getProcedureTypeText = value => {
  switch (value) {
    case 1:
      return PROCEDURE_TYPE.NewGasService;
    case 2:
      return PROCEDURE_TYPE.ReplenishmentResourceDenial;
    case 3:
      return PROCEDURE_TYPE.Feasibility;
    case 4:
      return PROCEDURE_TYPE.OtherRequest;
    default:
      return 'Trámite no válido';
  }
};

export const isEmailNotificationDisabled = () => {
  /** Request notifications (actually request response) can be via email or not.
   * But because of COVID-19, the only available way of send a notification should
   * be via email at least until an especific date, thus being 2021-05-31
   */
  const ENABLE_EMAIL_NOTIFICATION_DATE = moment(
    '2021-05-31',
    'YYYY-MM-DD'
  ).utc();

  const now = moment();

  return now.diff(ENABLE_EMAIL_NOTIFICATION_DATE, 'seconds') < 0;
};

export const IDENTIFICATION_OPTIONS = [
  { label: 'Cédula de ciudadanía', value: IDENTIFICATION_TYPES.CC },
  { label: 'Pasaporte', value: IDENTIFICATION_TYPES.PP },
  { label: 'Cédula de extranjería', value: IDENTIFICATION_TYPES.CE },
  { label: 'NIT', value: IDENTIFICATION_TYPES.NIT }
];

export const DEFAULT_SUBJECTS = {
  [REQUEST_TYPE.IndustrialOwnership]:
    'Solicitud de cambio de nombre o razón social',
  [REQUEST_TYPE.ContributionExemption]: 'Solicitud de exención contribución'
};

export const EMAIL_RESPONSE = {
  YES: '1',
  NO: '0'
};

export const VALID_FILE_EXTENSIONS = [
  'pdf',
  'doc',
  'docx',
  'jpg',
  'jpeg',
  'png'
];

const INDUSTRIAL_OWNERSHIP_ATTACHMENTS = [
  {
    label: 'Carta de cambio de titular',
    templateLink: './Formato-Cambio-de-Razon-Social.docx',
    validFileExtensions: ['pdf', 'doc', 'docx'],
    required: true
  },
  {
    label: 'Cámara de comercio no mayor a 30 días',
    required: true
  },
  {
    label: 'RUT no mayor a 30 días',
    required: true
  },
  {
    label: 'Cédula de ciudadanía del representante legal',
    required: true
  },
  {
    label: 'Certificado de libertad y tradición no mayor a 30 días',
    required: true
  },
  {
    label: 'Otros (opcional)',
    required: false,
    validFileExtensions: [...VALID_FILE_EXTENSIONS, 'zip']
  }
];

const INDUSTRIAL_CONTRIBUTION_EXEMPTION_ATTACHMENTS = [
  {
    label: 'Carta de exención debidamente firmada',
    templateLink: './Formato-Solicitud-Exencion-Contribucion-Industriales.docx',
    validFileExtensions: ['pdf', 'doc', 'docx'],
    required: true
  },
  {
    label: 'Cámara de comercio no mayor a 30 días',
    required: true
  },
  {
    label: 'RUT no mayor a 30 días',
    required: true
  },
  {
    label: 'Cédula de ciudadanía del representante legal',
    required: true
  }
];

export const CUSTOM_ATTACHMENTS = {
  [REQUEST_TYPE.IndustrialOwnership]: INDUSTRIAL_OWNERSHIP_ATTACHMENTS,
  [REQUEST_TYPE.ContributionExemption]: INDUSTRIAL_CONTRIBUTION_EXEMPTION_ATTACHMENTS
};
